<template>
  <div class="banner">
    <div class="banner__wrap">
      <div class="banner__content">
        <div
          class="banner__item"
          v-for="(item, index) in dataBanner"
          :key="index"
          @click="gotoGame(item)"
        >
          <img :src="renderSrcImage(item)" alt="banner" />

          <div class="banner__item--content">
            <div class="banner__text">
              <div class="banner__title" v-html="translatedWord(item.slug)"></div>
              <div class="banner__draw-date">
                <span v-if="item.drawDate">
                  {{
                    ["uk39s", "fast15s"].includes(item.slug)
                      ? getTranslatedText("Every 3 mins")
                      : renderHour(item.drawDate)
                  }}
                </span>
                <span v-if="item.drawDate1">
                  & {{ renderHour(item.drawDate1) }}</span
                >
              </div>
            </div>
            <div class="nextdraw__container">
              <p>{{ getTranslatedText("Next Draw") }}</p>
              <p class="nextdraw__time">{{ renderHour(item.drawDate) }}</p>
              <ButtonCommon text="play" @action="gotoGame(item)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language-mixins";
import utilsMixins from "@/mixins/function-utils";
import ButtonCommon from "@/components/common/button/index.vue";
import { notify } from "@/utils/notify";

export default {
  mixins: [languageMixins, utilsMixins],
  components: { ButtonCommon },
  data() {
    return {
      urlImage: process.env.VUE_APP_IMAGE_URL
    };
  },
  props: {
    dataBanner: {
      type: Array,
    },
  },
  methods: {
    gotoGame(item) {
      if (!item.drawDate) {
        notify({
          text: this.getTranslatedText(
            "draw limit reached. feel free to return for more later!"
          ),
          type: "error",
        });
        return;
      }
      const game = item.slug;
      const query = this.$route.query;
      this.$router.push({ path: `/coupons/${game}`, query });
    },

    renderSrcImage(item) {
      if (this.$store.state.isScreenMobile)
        return this.urlImage + item.banner_mobile;
      return this.urlImage + item.banner;
    },
    translatedWord(slug) {
      let text = this.getTranslatedText("The more you match, the more you win");
      if(slug === 'uk49s') {
        text = this.getTranslatedText("A four times daily, presenter -led live draw");
      }
      if(slug === 'fast15s') {
        text = this.getTranslatedText("Fast action draws, with more wins");
      }
      const words = text.split(' ');
      if (words.length > 1) {
        words[1] = `<span>${words[1]}</span>`;
        words[2] = `<span>${words[2]}</span>`;
      }
      return words.join(' ');
    },
  },
};
</script>

<style lang="scss">
@import "@/public/scss/banner/_index.scss";

.banner__item--content {
  flex-direction: row;
  padding: 0;

  .nextdraw__container {
    padding: 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: rgba($color: #000000, $alpha: 0.15);

    .button {
      width: 80px;
    }

    .nextdraw__time {
      font-size: 20px;
    }

    p {
      font-weight: bold;
      letter-spacing: 0.4px;
    }
  }

  .banner__text {
    max-width: 127px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .banner__title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      position: relative;
      padding-bottom: 15px;

      span {
        color: #ffd700;
      }

      &::before {
        content: "";
        width: 100px;
        height: 1px;
        background-color: #04489c;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }

    .banner__draw-date {
      font-size: 13px;
      color: #ffd700;
    }
  }

  @media (max-width: 768px) {
    .nextdraw__container {
      padding: 10px;
    }

    .banner__text {
      max-width: 100px;

      .banner__title {
        font-size: 14px;
        margin-bottom: 5px;
        padding-bottom: 10px;
      }
    }
  }

  @media (min-width: 769px) {
    .banner__text {
      max-width: 11vw;
    }
  }
}
</style>
